import React, { useState, useEffect, useRef } from "react";
import { LayoutHome } from "../LayoutHome";
import { Col, DatePicker, Panel, Row, SelectPicker, Text, Table } from "rsuite";
import moment from "moment/moment";
import { Button, Splitter, notification } from "antd";
import { LucideSearch } from "lucide-react";
import {
  getHorariosTurno,
  getTurnos,
  getResumenConsumoGlobal,
  getResumenConsumoPaciente,
} from "../Services/SesionHemoServices";
import { getListPacientes } from "../Services/PacientesServices";

const { Column, HeaderCell, Cell } = Table;

export const ConsumosSesion = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idPaciente, setIdPaciente] = useState("0");
  const [height, setHeight] = useState(30);
  const [data, setData] = useState([]);
  const [dataTurnos, setDataTurnos] = useState([]);
  const [dataHorarios, setDataHorarios] = useState([]);
  const [idTurno, setIdTurno] = useState(0);
  const [hora, setHora] = useState("00:00");
  const [dataPorPac, setDataPorPac] = useState([]);
  const [dataPacientes, setDataPacientes] = useState([]);
  const [dataResumenGlobal, setDataResumenGlobal] = useState([]);
  const [opc, setOpc] = useState(1);
  const [fecha, setFecha] = useState("");
  const [labelResumen, setLabelResumen] = useState("Resúmen");

  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const fetchHorarios = async (e) => {
    if (e === null) {
      setDataHorarios([]);
      setOpc(1);
      loadConsumoGlobal(fecha, "00:00", 1);
      return;
    }

    var fec = new Date(fecha).toISOString().substring(0, 10);
    setOpc(e === "MAT" ? 2 : 3);
    setIdTurno(e);
    
    await getHorariosTurno(idNegocio, e)
      .then(async (res) => {
        setDataHorarios(res);
        loadConsumoGlobal(fecha, "00:00", e === "MAT" ? 2 : 3);
        setLabelResumen(
          `Resúmen del día: ${fec} - Turno: ${e === "MAT" ? "Matutino" : "Vespertino"}`,
        );
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const loadConsumoGlobal = async (e, horaTurno, opcion) => {
    if (e === null) {
      setFecha("");
      setDataResumenGlobal([]);
      return;
    }
    if(horaTurno === null && opcion === 4){
      setHora("");
      fetchHorarios(idTurno);
      return;
    }

    setFecha(e);
    var fec = new Date(e).toISOString().substring(0, 10);

    setLabelResumen(`Resúmen del día: ${fec}`);

    if (opcion === 4) {
      setHora(horaTurno);
      setLabelResumen(`Resúmen del día: ${fec} - Por Horario: ${horaTurno.substring(0,5)}`);
    }

    
    await getResumenConsumoGlobal(idNegocio, fec, horaTurno, opcion)
      .then(async (res) => {
        setDataResumenGlobal(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadTurnos = async () => {
    await getTurnos(idNegocio)
      .then(async (res) => {
        setDataTurnos(res);
        loadPacientes();
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };


  const loadResumenPorPaciente = async (e) => {
    if(e === null){
      setDataPorPac([]);
      return;
    }
    var fec = new Date(fecha).toISOString().substring(0, 10);
    await getResumenConsumoPaciente(idNegocio, fec, e).then(res => {
      setDataPorPac(res);
    }).catch(err => {
      errorNotificaction(err.name, err.message);
    });
  };


  const loadPacientes = async (e) => {
    if (e === null) {
      setDataPacientes([]);
      return;
    }

    await getListPacientes(idNegocio)
      .then((res) => {
        setDataPacientes(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadTurnos();
    }
  }, []);

  return (
    <div>
      <title>Consumos Sesión</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Consumos de la sesión" },
        ]}
        selectedKey={"ConsumosSesion"}
      >
        {contextHolder}
        <Panel
          bordered
          header={<Text>Consumos - Sesiones de Hemodiálisis</Text>}
        >
          <Row gutter={10}>
            <Col span={2}>
              <Text weight="semibold">Fecha</Text>
              <DatePicker
                value={fecha}
                onChange={(e) => loadConsumoGlobal(e, "00:00", 1)}
              />
            </Col>
            <Col span={4}>
              <Text weight="semibold">Turno</Text>
              <SelectPicker
                placeholder="--SELECCIONA--"
                searchable={false}
                data={dataTurnos}
                onChange={(e) => fetchHorarios(e)}
                block
              />
            </Col>
            <Col span={3}>
              <Text size={"sm"} weight="semibold">
                Horario
              </Text>
              <SelectPicker
                block
                searchable={false}
                value={hora}
                data={dataHorarios}
                placeholder="--HORARIO--"
                onChange={(e) => loadConsumoGlobal(fecha, e, 4)}
              />
            </Col>
            <Col span={8}>
              <Text weight="semibold">Paciente</Text>
              <SelectPicker
                data={dataPacientes}
                block
                placeholder="--SELECCIONA--"
                onChange={(e) => loadResumenPorPaciente(e)}
              />
            </Col>
            
          </Row>
        </Panel>
        <br></br>
        <Splitter>
          <Splitter.Panel
            style={{ padding: "10px", overflowX: "hidden" }}
            defaultSize="40%"
            min="30%"
            max="80%"
          >
            <Panel bordered header={<Text>{labelResumen}</Text>}>
              <Table
                height={400}
                data={dataResumenGlobal}
                bordered
                key={"Todos"}
              >
                <Column flexGrow={1}>
                  <HeaderCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Insumo
                  </HeaderCell>
                  <Cell dataKey="nombreInsumo" />
                </Column>

                <Column flexGrow={1} align="center">
                  <HeaderCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Cantidad
                  </HeaderCell>
                  <Cell dataKey="cantidad" />
                </Column>
              </Table>
            </Panel>
          </Splitter.Panel>
          <Splitter.Panel
            style={{ padding: "10px", overflowX: "hidden" }}
            defaultSize="60%"
            min="30%"
            max="80%"
          >
            <Panel bordered header={<Text>Resúmen por Paciente</Text>}>
              <Table height={400} data={dataPorPac} bordered key={"Paciente"}>
                <Column
                  flexGrow={1}
                  verticalAlign="middle"
                >
                  <HeaderCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Paciente
                  </HeaderCell>
                  <Cell dataKey="nomPaciente" />
                </Column>

                <Column flexGrow={1}>
                  <HeaderCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Insumo
                  </HeaderCell>
                  <Cell dataKey="nombreInsumo" />
                </Column>

                <Column flexGrow={1} align="center">
                  <HeaderCell style={{ fontWeight: "bold", fontSize: "16px" }}>
                    Cantidad
                  </HeaderCell>
                  <Cell dataKey="cantidad" />
                </Column>
              </Table>
            </Panel>
          </Splitter.Panel>
        </Splitter>
      </LayoutHome>
    </div>
  );
};
